<template>
  <nav class="flex-grow flex justify-end relative">
    <!-- horizontal menu for medium and larger screens -->
    <ul
      class="hidden lg:inline-flex flex-grow leading-normal justify-between pl-4 text-gray-600 text-xs"
    >
      <li data-test="rename">
        <router-link
          :to="{ name: 'edit' }"
          class="flex items-center h-8 px-2 py-1 transition duration-150 rounded-full hover:bg-gray-300 hover:text-gray-900"
        >
          <svg class="h-3 mr-2 fill-current" viewBox="0 0 12 12">
            <path :d="pencilPath" />
          </svg>
          Umbenennen
        </router-link>
      </li>
      <li data-test="delete">
        <router-link
          :to="{ name: 'confirm' }"
          class="flex items-center h-8 px-2 py-1 transition duration-150 rounded-full hover:bg-gray-300 hover:text-gray-900"
        >
          <svg class="h-3 mr-2 fill-current" viewBox="0 0 12 14">
            <path :d="trashCanPath" />
          </svg>
          Löschen
        </router-link>
      </li>
      <li data-test="choose-folder-template" v-if="showChooseFolderTemplate">
        <router-link
          :to="{ name: 'choose-folder-template' }"
          class="flex items-center h-8 px-4 py-1 transition duration-150 rounded-full hover:bg-gray-300 hover:text-gray-900"
        >
          <svg class="h-3 mr-2 fill-current" viewBox="0 0 12 12">
            <path :d="folderTemplatePath" />
          </svg>
          Vorlagen
        </router-link>
      </li>

      <li class="ml-auto">
        <button
          @click.prevent="getPdf"
          :title="titleCreateDossier"
          class="flex items-center h-8 px-2 py-1 font-medium transition duration-150 rounded-full hover:bg-gray-300 hover:text-blue-dark text-small text-blue whitespace-no-wrap"
        >
          <svg class="h-4 mr-2 fill-current" viewBox="0 0 18 16">
            <path :d="bookPath" />
          </svg>
          Dossier erstellen
        </button>
      </li>

      <li class="ml-4">
        <button
          class="inline-flex items-center h-8 px-3 py-1 -mx-3 font-medium transition duration-150 rounded-full hover:bg-gray-300 hover:text-blue-dark text-small text-blue whitespace-no-wrap"
          @click.prevent="printPdf"
          :title="titlePrintBrowserView"
        >
          <svg class="h-4 mr-2 fill-current" viewBox="0 0 20 18">
            <path :d="printerPath" />
          </svg>
          Ansicht drucken
        </button>
      </li>
    </ul>

    <!-- drop down menu for small screens -->
    <button
      class="text-sm lg:hidden bg-blue px-4 h-8 block text-white whitespace-no-wrap"
      @click="dropdownOpen = !dropdownOpen"
    >
      <span class="hidden mr-1 middots">&middot;&middot;&middot;</span>
      Aktionen
    </button>
    <div
      @click="dropdownOpen = false"
      class="fixed inset-0 w-full h-full bg-black opacity-60 z-10 cursor-default"
      v-if="dropdownOpen"
      tabindex="-1"
    ></div>
    <ul
      class="lg:hidden flex-col absolute z-20 bg-white leading-normal text-small border border-b-0 border-gray-300"
      style="top: 2.2rem"
      v-show="dropdownOpen"
      @click="dropdownOpen = false"
    >
      <li class="w-56 border-b">
        <button
          @click.prevent="getPdf"
          class="flex items-center py-3 px-2 w-full font-medium transition duration-150 hover:text-blue text-small whitespace-no-wrap"
        >
          <svg class="w-8 h-4 mr-4 fill-current" viewBox="0 0 18 16">
            <path :d="bookPath" />
          </svg>
          Dossier erstellen
        </button>
      </li>
      <li class="w-56 border-b">
        <button
          @click.prevent="printPdf"
          class="flex items-center py-3 px-2 font-medium transition duration-150 hover:text-blue text-small whitespace-no-wrap"
        >
          <svg class="w-8 h-4 mr-4 fill-current" viewBox="0 0 20 18">
            <path :d="printerPath" />
          </svg>
          Ansicht drucken
        </button>
      </li>
      <li class="w-56 border-b" data-test="rename">
        <router-link
          :to="{ name: 'edit' }"
          class="flex items-center py-3 px-2 font-medium transition duration-150 hover:text-blue text-small whitespace-no-wrap"
        >
          <svg class="w-8 h-4 mr-4 fill-current" viewBox="0 0 12 12">
            <path :d="pencilPath" />
          </svg>
          Umbenennen
        </router-link>
      </li>
      <li class="w-56 border-b" data-test="delete">
        <router-link
          :to="{ name: 'confirm' }"
          class="flex items-center py-3 px-2 font-medium transition duration-150 hover:text-blue text-small whitespace-no-wrap"
        >
          <svg class="w-8 h-4 mr-4 fill-current" viewBox="0 0 12 14">
            <path :d="trashCanPath" />
          </svg>
          Löschen
        </router-link>
      </li>
      <li
        class="w-56 border-b"
        data-test="choose-folder-template"
        v-if="showChooseFolderTemplate"
      >
        <router-link
          :to="{ name: 'choose-folder-template' }"
          class="flex items-center py-3 px-2 font-medium transition duration-150 hover:text-blue text-small whitespace-no-wrap"
        >
          <svg class="w-8 h-4 mr-4 fill-current" viewBox="0 0 12 12">
            <path :d="folderTemplatePath" />
          </svg>
          Vorlagen
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import store from "@/store";

export default Vue.extend({
  data() {
    return {
      dropdownOpen: false,
      bookPath:
        "M16 12.4023L10 13.7503V3.59735L16 2.25035V12.4023ZM2 2.25035L8 3.59735V13.7503L2 12.4023V2.25035ZM17.625 0.218347C17.387 0.0293475 17.077 -0.0426523 16.78 0.0243477L9 1.77235L1.22 0.0243477C0.922 -0.0436523 0.613 0.0293475 0.375 0.218347C0.138 0.409347 0 0.696347 0 1.00035V13.2023C0 13.6703 0.324 14.0753 0.78 14.1773L8.78 15.9753C8.854 15.9923 8.927 16.0003 9 16.0003C9.073 16.0003 9.146 15.9923 9.22 15.9753L17.22 14.1773C17.676 14.0753 18 13.6703 18 13.2023V1.00035C18 0.696347 17.862 0.409347 17.625 0.218347Z",
      pencilPath:
        "M8.67907 5.11908L6.8824 3.32241L8.18107 2.02308L9.97707 3.81908L8.67907 5.11908ZM4.05307 9.74974L2.0684 9.93041L2.2444 7.95974L5.98907 4.21508L7.7864 6.01241L4.05307 9.74974ZM10.9357 2.89174L10.9351 2.89108L9.10974 1.06574C8.61574 0.573076 7.76707 0.549742 7.29907 1.01974L1.30174 7.01708C1.0844 7.23374 0.949737 7.52174 0.921737 7.82641L0.669071 10.6064C0.651737 10.8031 0.721737 10.9977 0.861737 11.1377C0.987737 11.2637 1.15774 11.3331 1.33307 11.3331C1.35374 11.3331 1.37374 11.3324 1.39374 11.3304L4.17374 11.0777C4.47907 11.0497 4.7664 10.9157 4.98307 10.6991L10.9811 4.70108C11.4664 4.21441 11.4457 3.40241 10.9357 2.89174Z",
      trashCanPath:
        "M7.11111 0.333374C8.05789 0.333374 8.8318 1.07347 8.88587 2.00669L8.88889 2.11115L8.88881 2.70367L11.2593 2.70374C11.5593 2.70374 11.8072 2.92668 11.8464 3.21593L11.8519 3.29634C11.8519 3.62362 11.5865 3.88893 11.2593 3.88893L10.6659 3.88841L10.6667 11.5926C10.6667 12.5394 9.92657 13.3133 8.99335 13.3674L8.88889 13.3704H2.96296C2.01619 13.3704 1.24228 12.6303 1.1882 11.6971L1.18519 11.5926L1.18474 3.88841L0.592593 3.88893C0.292586 3.88893 0.0446492 3.66599 0.00540975 3.37675L0 3.29634C0 2.96906 0.265313 2.70374 0.592593 2.70374L2.96267 2.70367L2.96296 2.11115C2.96296 1.16438 3.70306 0.390464 4.63628 0.336392L4.74074 0.333374H7.11111ZM9.48118 3.88841H2.3703L2.37037 11.5926C2.37037 11.8965 2.59914 12.147 2.89385 12.1812L2.96296 12.1852H8.88889C9.19279 12.1852 9.44326 11.9565 9.47749 11.6617L9.48148 11.5926L9.48118 3.88841ZM7.11111 5.66671C7.43839 5.66671 7.7037 5.93202 7.7037 6.2593V9.81486C7.7037 10.1421 7.43839 10.4074 7.11111 10.4074C6.78383 10.4074 6.51852 10.1421 6.51852 9.81486V6.2593C6.51852 5.93202 6.78383 5.66671 7.11111 5.66671ZM4.74074 5.66671C5.06802 5.66671 5.33333 5.93202 5.33333 6.2593V9.81486C5.33333 10.1421 5.06802 10.4074 4.74074 10.4074C4.41346 10.4074 4.14815 10.1421 4.14815 9.81486V6.2593C4.14815 5.93202 4.41346 5.66671 4.74074 5.66671ZM7.11111 1.51856H4.74074C4.43684 1.51856 4.18637 1.74732 4.15213 2.04204L4.14815 2.11115L4.14741 2.70367H7.70326L7.7037 2.11115C7.7037 1.80725 7.47494 1.55678 7.18022 1.52255L7.11111 1.51856Z",
      folderTemplatePath:
        "M10 0H10.6667C11.4031 0 12 0.596954 12 1.33333V10.6667C12 11.403 11.4031 12 10.6667 12H10C9.26364 12 8.66669 11.403 8.66669 10.6667V1.33333C8.66669 0.596954 9.26364 0 10 0ZM10 1.33333V10.6667H10.6667V1.33333H10ZM2.00002 0H2.66669C3.40307 0 4.00002 0.596954 4.00002 1.33333V10.6667C4.00002 11.403 3.40307 12 2.66669 12H2.00002C1.26364 12 0.666687 11.403 0.666687 10.6667V1.33333C0.666687 0.596954 1.26364 0 2.00002 0ZM2.00002 1.33333V10.6667H2.66669V1.33333H2.00002ZM6.00002 0H6.66669C7.40307 0 8.00002 0.596954 8.00002 1.33333V10.6667C8.00002 11.403 7.40307 12 6.66669 12H6.00002C5.26364 12 4.66669 11.403 4.66669 10.6667V1.33333C4.66669 0.596954 5.26364 0 6.00002 0ZM6.00002 1.33333V10.6667H6.66669V1.33333H6.00002Z",
      printerPath:
        "M17.36 4H16V2C16.0217 1.49233 15.8413 0.99675 15.4983 0.621863C15.1553 0.246976 14.6776 0.023355 14.17 0H5.83002C5.32242 0.023355 4.84478 0.246976 4.50175 0.621863C4.15873 0.99675 3.97831 1.49233 4.00002 2V4H2.64002C1.93628 4.00529 1.26331 4.28924 0.7685 4.78968C0.273686 5.29011 -0.00264646 5.96625 1.91069e-05 6.67V13.33C-0.00264646 14.0338 0.273686 14.7099 0.7685 15.2103C1.26331 15.7108 1.93628 15.9947 2.64002 16H3.50002C3.50002 16.5304 3.71073 17.0391 4.08581 17.4142C4.46088 17.7893 4.96959 18 5.50002 18H14.5C15.0305 18 15.5392 17.7893 15.9142 17.4142C16.2893 17.0391 16.5 16.5304 16.5 16H17.36C18.0638 15.9947 18.7367 15.7108 19.2315 15.2103C19.7264 14.7099 20.0027 14.0338 20 13.33V6.67C20.0027 5.96625 19.7264 5.29011 19.2315 4.78968C18.7367 4.28924 18.0638 4.00529 17.36 4ZM6.00002 2H14V4H6.00002V2ZM5.50002 16V12H14.5V16H5.50002ZM18 13.33C18.0027 13.5034 17.9371 13.6708 17.8174 13.7962C17.6976 13.9216 17.5333 13.9948 17.36 14H16.5V12C16.5 11.4696 16.2893 10.9609 15.9142 10.5858C15.5392 10.2107 15.0305 10 14.5 10H5.50002C4.96959 10 4.46088 10.2107 4.08581 10.5858C3.71073 10.9609 3.50002 11.4696 3.50002 12V14H2.64002C2.46672 13.9948 2.30244 13.9216 2.18269 13.7962C2.06293 13.6708 1.99731 13.5034 2.00002 13.33V6.67C1.99731 6.49664 2.06293 6.32919 2.18269 6.20382C2.30244 6.07845 2.46672 6.00523 2.64002 6H17.36C17.5333 6.00523 17.6976 6.07845 17.8174 6.20382C17.9371 6.32919 18.0027 6.49664 18 6.67V13.33Z"
    };
  },
  props: {
    folderId: {
      type: String,
      required: true
    },
    showChooseFolderTemplate: {
      type: Boolean,
      default: false
    },
    titleCreateDossier: {
      type: String,
      default: "Alle Elemente mit Detailansicht als PDF erstellen"
    },
    titlePrintBrowserView: {
      type: String,
      default: "Alle Elemente als Kurzansicht drucken"
    }
  },
  methods: {
    async getPdf() {
      const uri = await this.getUri();
      // With 20 max tries, a 500ms initial timer and a 1.25x multiplier
      // the total time before timeout will be just below 3 mins.
      // and the interval before the last attempt will be around 30secs.
      const MAX_TRIES = 20;
      const TIMER = 500;
      this.attemptDownload(MAX_TRIES, TIMER, uri);
    },
    async getUri() {
      const { data } = await axios({
        method: "post",
        url: store.state.stageConfig.renderBase,
        headers: {
          authorization: `Bearer ${localStorage.getItem("dpaID-token")}`
        },
        data: { format: "pdf", folderId: this.folderId }
      });
      return data.uri;
    },
    attemptDownload(MAX_TRIES, TIMER, uri) {
      const MULTIPLIER = 1.25;
      if (MAX_TRIES >= 0) {
        setTimeout(async () => {
          try {
            await axios.get(uri);
            window.location.href = uri;
          } catch (e) {
            MAX_TRIES -= 1;
            TIMER = TIMER * MULTIPLIER;
            this.attemptDownload(MAX_TRIES, TIMER, uri);
          }
        }, TIMER);
      }
    },
    printPdf() {
      window.print();
    }
  }
});
</script>

<style scoped>
@media (min-width: 360px) {
  .middots {
    display: inline;
  }
}
</style>
